module.exports = __webpack_public_path__ + "img/th.76fca72f.svg";